module.exports = __webpack_public_path__ + "img/app-screenshot_3x.8671318b.png";